export default "__VITE_PUBLIC_ASSET__d840f935__"